<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {};
    },

    mounted() {}
};
</script>

<style>
/* 路由切换动画 */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
    will-change: transform;
    transition: all 300ms;
    position: fixed;
}
.slide-right-enter {
    opacity: 0;
    transform: translateX(-100%);
}
.slide-right-leave-active {
    opacity: 0;
    transform: translateX(100%);
}
.slide-left-enter {
    opacity: 0;
    transform: translateX(100%);
}
.slide-left-leave-active {
    opacity: 0;
    transform: translateX(-100%);
}

.border_bottom {
    border-bottom: 1px #e5e5e5 solid;
}
.box_shadow {
    box-shadow: 0px -5px 9px -8px #b4b3b3;
}
.big_img {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue